import { Component, Input, OnInit } from '@angular/core';
import { MasterApiService } from 'src/app/services/master-api.service';
import { GenericReadOnlyResource } from 'src/app/resources';
import { Batch, ContainerTraceability } from 'src/app/models';
import { Scrolling } from 'devextreme/ui/data_grid';
import { generateGuid } from 'src/app/libs/utils';

@Component({
    selector: 'app-product-batch-movements',
    templateUrl: './product-batch-movements.component.html',
    styleUrl: './product-batch-movements.component.sass',
    standalone: false
})
export class ProductBatchMovementsComponent implements OnInit {
  @Input() entity?: Batch;
  traceability?: GenericReadOnlyResource<ContainerTraceability>;
  scrolling: Scrolling = { mode: 'virtual', columnRenderingMode: 'standard' };
  paging = { enabled: true };

  constructor(private api:MasterApiService) { }

  ngOnInit(): void {
    this.traceability = this.api.resources.traceability
      .contextualizeQueryParams({ goodId: this.entity!.id as string })
      .asMappedResource<ContainerTraceability>({
        from: async row => ({
          ...row,
          id: generateGuid(),
          inventoryReconciliationValue: row.inventoryReconciliationValue ?? 0,
        }),
      });
  }
}
